import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ProjectDiagramationAddComponent } from '../../shared/dialogs/project-diagramation-add/project-diagramation-add.component';
import { ProjectDiagramationVobosComponent } from '../../shared/dialogs/project-diagramation-vobos/project-diagramation-vobos.component';
import { ProjectDiagramationVobosConfigComponent } from '../../shared/dialogs/project-diagramation-vobos-config/project-diagramation-vobos-config.component';
import { ProjectsArtUploadComponent } from '../../shared/dialogs/projects-art-upload/projects-art-upload.component';
import { ProjectsDiagramationInventoryComponent } from '../../shared/dialogs/projects-diagramation-inventory/projects-diagramation-inventory.component';
import { ProjectsDiagramationDistributionComponent } from '../../shared/dialogs/projects-diagramation-distribution/projects-diagramation-distribution.component';
import { ProjectModel, ProjectPhase, ProjectVobo, ProjectCampaignModel } from 'src/app/models/project.model';
import { CutoffService } from 'src/app/services/cutoff.service';
import { ProjectsProvidersListComponent } from '../../shared/dialogs/projects-providers-list/projects-providers-list.component';
import { UsersService } from 'src/app/services/users.service';
import { DiagramsLogsComponent } from '../../shared/dialogs/diagrams-logs/diagrams-logs.component';
import { UsuariosSigVoboComponent } from '../../shared/dialogs/usuarios-sig-vobo/usuarios-sig-vobo.component';
import { DatePipe } from '@angular/common';

import { ProjectsCampaignFileMultiAddComponent } from '../../shared/dialogs/projects-campaign-file-multiadd/projects-campaign-file-multiadd.component';
import { ProjectsArtMultiUploadComponent } from '../../shared/dialogs/projects-art-multiupload/projects-art-multiupload.component';
import { Subject, Subscription, takeUntil, timer } from 'rxjs';
import { ProjectDiagramResetsComponent } from '../../shared/dialogs/project-diagram-resets/project-diagram-resets.component';

import { ProjectDiagramationResumenComponent } from '../../shared/dialogs/project-diagramation-resumen/project-diagramation-resumen.component';
import { ProjectDiagramationSummaryInventoryComponent } from '../../shared/dialogs/project-diagramation-summary-inventory/project-diagramation-summary-inventory.component';
import { ProjectDiagramationImportComponent } from '../../shared/dialogs/project-diagramation-import/project-diagramation-import.component';
import { ProjectDiagramationExportComponent } from '../../shared/dialogs/project-diagramation-export/project-diagramation-export.component';
import { SharedArtsDiagramViewComponent } from '../../shared/dialogs/shared-arts-diagram-view/shared-arts-diagram-view.component';

@Component({
  selector: 'app-project-diagramation',
  templateUrl: './project-diagramation.component.html',
  styleUrls: ['./project-diagramation.component.scss'],
  providers: [DatePipe]
})
export class ProjectDiagramationComponent implements OnInit, OnDestroy {

  firstLoadCompleted : boolean = false;

  project: ProjectModel = new ProjectModel();
  id_proy: number = 0;
  projectConfig: any = new Array<ProjectPhase>();
  projectDiagramations: any= new Array<ProjectVobo>();
  myProjectDiagramations: any= new Array<ProjectVobo>();
  showProjectDiagramations: any= new Array<ProjectVobo>();
  allProjectDiagramations: any= new Array<ProjectVobo>();
  projectAllDiagramations: any= new Array<ProjectVobo>();
  projectAllDiagramationsConfig: any= []; 
  projectPhases: any = new Array<ProjectPhase>();
  diagram_files!: any;
  campaign: ProjectCampaignModel = new ProjectCampaignModel();
  config_positions: any = [];
  form_vb: any = [];
  arr_order: any = [];
  projectResponse : any;
  userId : number = 0;
  searchText: string = '';
  fechaActual: Date;
  fechaFormateada: string | null = null;
  fechaDot:any = []
  mydiag:any = [];
  selectVerDiagramacion: string = '1';
  selectDiagramacionFiltro: string = '4';
  fechaSigVobo: string = '';
  id_proy_camp : number = 0;
  displayedColumns: string[] = [];
  selectedColumns: string[] = [];
  loadingPromColumns : boolean = true;
  tieneColGuardadas: boolean = true;
  columnsProm: string[] = [];
  allColumns: string[] = [];
  pop_config : any = [];
  art_users : any;
  menciones : any = [];
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  // New properties to cache permission checks
  canCreateDiagram: boolean = false;
  canViewInventory: boolean = false;
  canDistribute: boolean = false;
  canDownloadPaymentData: boolean = false;
  canUploadArts: boolean = false;
  canGenerateExcel: boolean = false;
  canEditDiagramItem: boolean = false;
  canResetVoboItem: boolean = false;
  canDeleteDiagramItem: boolean = false;
  private isDragging = false;
  private startX!: number;
  private scrollLeft!: number;

  private pollingSubscription: Subscription | undefined;
  private stopPolling$ = new Subject<void>();
  private destroy$ = new Subject<void>();


  constructor( private matDialog: MatDialog,
    private projectsS: ProjectsService,
    private _params: ActivatedRoute,
    private main: MainService,
    private _cutoffS : CutoffService,
    private userS : UsersService,
    private datePipe: DatePipe,
    private _router: Router) {
      this.project = new ProjectModel();
      this.userId = userS.getUser().id;
      this._params.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
        if(params.projid){
          this.id_proy = params.projid;
          this.projectsS.checkIfSameThenReplace(this.id_proy).then((e:any)=>{
            this.campaign = this.projectsS.current_campaign;
            this.project = this.projectsS.current_project;
          }).catch(err=>{
            console.log(err);
            this._router.navigateByUrl('/admin/dashboard');  
          });
        }else{
          this._router.navigateByUrl('/admin/dashboard');
        } 
      });
      this._params.queryParams.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
        if (queryParams.find) {
          this.searchText = queryParams.find;
        }
      });
      this.fechaActual = new Date();
    }

  ngOnInit(): void {
    this.loadProyectData();
    this.startPolling()
    this.selectVerDiagramacion = '1';

    this.canCreateDiagram = this.hasPermissions('crear_diag', null, true);
    this.canViewInventory = this.hasPermissions('ver_inv_diag', null, true);
    this.canDistribute = this.hasPermissions('dist_diag', null, true);
    this.canDownloadPaymentData = this.hasPermissions('datos_pago', null, true);
    this.canUploadArts = this.hasPermissions('upl_artes', null, true);
    this.canGenerateExcel = this.hasPermissions('gen_excel', null, true);
    this.canEditDiagramItem = this.hasPermissions('editar_diag', null, true);
    this.canResetVoboItem = this.hasPermissions('reset_vobo', null, true);
    this.canDeleteDiagramItem = this.hasPermissions('del_diag', null, true);

    if(this.userS.hasPermissions("diagram_super", null, this.userS.isClientUsr())){
      this.selectVerDiagramacion = '2';
    }
  }

  ngOnDestroy(): void {
    this.stopPolling$.next();
    this.stopPolling$.complete();
    this.destroy$.next();
    this.destroy$.complete();

    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  startPolling() {
    this.pollingSubscription?.unsubscribe();
    this.pollingSubscription = timer(30000, 30000).subscribe(() => {
      if (this.firstLoadCompleted) {
        this.silentLoadProjectData();
      }
    });
  }

  allpromos : Array<any>= []
  selected_medios : any = [];
  mediosConImagenesCompartidas = new Set<number>();
  catalogoImagenesCompartidasCargado = false;
  selected_attributes : any = [];
  t0: Date = new Date();

  private getT0(projectData: any, allDiagramations: any[]): Date {
    if (allDiagramations && allDiagramations.length > 0) {
      const oldestDiagram = allDiagramations.reduce((oldest: any, current: any) => {
        return new Date(current.created_at) < new Date(oldest.created_at) ? current : oldest;
      });
      return new Date(oldestDiagram.created_at);
    }

    return projectData.project[0].t_zero ? new Date(projectData.project[0].t_zero) : new Date();
  }

  loadProyectData() {
    this.main.ShowLoading();
    this.projectsS.getUsersByPermiso("upl_artes").subscribe((x: any) => {

      this.art_users = x.data;
      this.main.ShowLoading();
    this.projectsS.getProjectConfig(this.id_proy).subscribe((x: any) => {
      this.main.HideLoading();
      this.menciones = x.data.menciones;
      this.projectAllDiagramations = x.data.diagram_all;
      this.projectResponse = x.data.project;
      this.pop_config = x.data.diagram_pop_config;

      this.canCreateDiagram = this.hasPermissions('crear_diag', null, true);
      this.canViewInventory = this.hasPermissions('ver_inv_diag', null, true);
      this.canDistribute = this.hasPermissions('dist_diag', null, true);
      this.canDownloadPaymentData = this.hasPermissions('datos_pago', null, true);
      this.canUploadArts = this.hasPermissions('upl_artes', null, true);
      this.canGenerateExcel = this.hasPermissions('gen_excel', null, true);
      this.canEditDiagramItem = this.hasPermissions('editar_diag', null, true);
      this.canResetVoboItem = this.hasPermissions('reset_vobo', null, true);
      this.canDeleteDiagramItem = this.hasPermissions('del_diag', null, true);
      if(!this.projectResponse[0].fecha_inicio){
              this.t0 = this.getT0(x.data, this.projectAllDiagramations);
      }else{
            this.t0 = this.projectResponse[0].fecha_inicio;
      }
      const t0Deadline = new Date(this.t0); 

      this.projectPhases = x.data.data.map((e:ProjectPhase)=> {
        e.vobos.map((v:ProjectVobo)=>{
          return Object.assign(v, {fecha_limite: this.main.addDays(t0Deadline,v.scheluded_time_days)});
        })
        return Object.assign(e, {fecha_limite: this.main.addDays(t0Deadline,e.scheluded_time_days)});
      });

      this.projectDiagramations = x.data.diagram;

      this.config_positions = x.data.config_positions;
      this.diagram_files = x.data.diagram_files;
      this.form_vb = x.data.form_vb;
      
      this.id_proy_camp = x.data.project[0].id_proy_camp;
      this.selected_medios = x.data.project[0].selected_medios ? JSON.parse(x.data.project[0].selected_medios) : []
      this.cargarMediosConImagenesCompartidas();

      this.selected_attributes = x.data.project[0].selected_attributes ? JSON.parse(x.data.project[0].selected_attributes) : []
      ///console.log(this.selected_medios);

      
      this.projectPhases.map((c:any)=> {
        this.arr_order.push({ tipo: "art", id_fase: c.id });
        c.vobos.map((vobo:any)=> {
          this.arr_order.push({ tipo: vobo.is_provider_vobo==1?"prov":"vobo", id_fase: c.id, id_vobo: vobo.id });
        })
      });

      this.allpromos = x.data.diagram.flatMap((item:any) => Object.values(item.promociones));

      //Para poner circulo rojo a lado de la fecha
      //Saber fecha actual, despues obtener todas las fechas anteriores o igual a la fecha actual, de esas obtengo la maxima, y en esa es donde ira el punto rojo
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      this.projectPhases.map( (pp:any) => {
        pp.fecha_limite.setHours(0, 0, 0, 0);
        //Fechas de artes
        if(pp.fecha_limite <= today){
          this.fechaDot.push(pp.fecha_limite)
        }
        //Fechas de vobos
        pp.vobos.map( (vb:any) => {
          vb.fecha_limite.setHours(0, 0, 0, 0);
          if(vb.fecha_limite <= today){
            this.fechaDot.push(vb.fecha_limite)
          }
        })
      })

      if(this.fechaDot.length > 0){
        const fechaMaximaDot = new Date(Math.max(...this.fechaDot.map((d: Date) => d.getTime())));
        this.fechaFormateada = this.datePipe.transform(fechaMaximaDot, 'dd/MM/yyyy');
      }

      //Diagramaciones donde las que tengo que dar vobo
      this.allProjectDiagramations = this.projectDiagramations;
      let encontroUser;
      this.mydiag = [];

      this.projectDiagramations.map( (diagramation:any) => {
        const conf_vobos = diagramation.config_vobos;
        conf_vobos.map((cv:any) => {
          const vobos = cv.vobos;
          vobos.map((vb:any) => {
            encontroUser = vb.users.find( (user:any) => user == x.my_user_id);
            if(encontroUser != undefined){
              if (!this.mydiag.includes(diagramation.id)) {
                this.mydiag.push(diagramation.id);
              }
            }
          })
        })
      });

      this.myProjectDiagramations = this.projectDiagramations.filter( (obj:any) => {
        return this.mydiag.includes(obj.id);
      });



      this.updateSelectDiagramations(); 
      this.firstLoadCompleted = true;
      //Se agrega porcentaje de terminado a cada vobo
      this.projectPhases.map( (pp:any) => {

        //Se agrega primero a las phases de artes
        const files_aprobados = this.diagram_files.filter( (df:any) => df.id_phase == pp.id && df.aprobado == 1);
        
        const totalDiagramations = this.projectDiagramations.length;
        const porcentaje_terminado = totalDiagramations > 0 ? Number(((files_aprobados.length / totalDiagramations) * 100).toFixed(2)) : 0;        
          
        pp.porcentaje_terminado = porcentaje_terminado;

        //Despues a los vobos
        pp.vobos.map((vb:any) => {
          let count_vobos_aprov = 0;
          this.projectDiagramations.map((pd:any) => {
            const c_vobos = pd.config_vobos.find( (cv:any) => cv.id == pp.id );
            count_vobos_aprov += c_vobos.vobos.filter( (vo:any) => vo.id == vb.id && vo.status == 1 ).length;
          })
      
          vb.porcentaje_terminado = totalDiagramations > 0 ? Number(((count_vobos_aprov / totalDiagramations) * 100).toFixed(2)) : 0;

        })

      })

    },
    (err:any) => {
      console.log(err);
          this.main.HideLoading();
    });

    });
  }

  silentLoadProjectData() {
   this.arr_order = [];

    this.projectsS.getProjectConfig(this.id_proy).subscribe((x: any) => {
      this.menciones = x.data.menciones;
      this.projectAllDiagramations = x.data.diagram_all;
      this.projectResponse = x.data.project;

      if(!this.projectResponse[0].fecha_inicio){
              this.t0 = this.getT0(x.data, this.projectAllDiagramations);
      }else{
            this.t0 = this.projectResponse[0].fecha_inicio;
      }
      const t0Deadline = new Date(this.t0);

      this.projectPhases = x.data.data.map((e:ProjectPhase)=> {
        e.vobos.map((v:ProjectVobo)=>{
          return Object.assign(v, {fecha_limite: this.main.addDays(t0Deadline,v.scheluded_time_days)});
        })
        return Object.assign(e, {fecha_limite: this.main.addDays(t0Deadline,e.scheluded_time_days)});
      });

      this.projectDiagramations = x.data.diagram;
     
      this.config_positions = x.data.config_positions;
      this.diagram_files = x.data.diagram_files;
      this.form_vb = x.data.form_vb;
      this.projectResponse = x.data.project;
      this.id_proy_camp =  x.data.project[0].id_proy_camp;
      this.selected_medios = x.data.project[0].selected_medios ? JSON.parse(x.data.project[0].selected_medios) : []
      this.cargarMediosConImagenesCompartidas();

      this.selected_attributes = x.data.project[0].selected_attributes ? JSON.parse(x.data.project[0].selected_attributes) : []


      
      this.projectPhases.map((c:any)=> {
        this.arr_order.push({ tipo: "art", id_fase: c.id });
        c.vobos.map((vobo:any)=> {
          this.arr_order.push({ tipo: vobo.is_provider_vobo==1?"prov":"vobo", id_fase: c.id, id_vobo: vobo.id });
        })
      });

      this.allpromos = x.data.diagram.flatMap((item:any) => Object.values(item.promociones));

      //Para poner circulo rojo a lado de la fecha
      //Saber fecha actual, despues obtener todas las fechas anteriores o igual a la fecha actual, de esas obtengo la maxima, y en esa es donde ira el punto rojo
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      this.projectPhases.map( (pp:any) => {
        pp.fecha_limite.setHours(0, 0, 0, 0);
        //Fechas de artes
        if(pp.fecha_limite <= today){
          this.fechaDot.push(pp.fecha_limite)
        }
        //Fechas de vobos
        pp.vobos.map( (vb:any) => {
          vb.fecha_limite.setHours(0, 0, 0, 0);
          if(vb.fecha_limite <= today){
            this.fechaDot.push(vb.fecha_limite)
          }
        })
      })

      if(this.fechaDot.length > 0){
        const fechaMaximaDot = new Date(Math.max(...this.fechaDot.map((d: Date) => d.getTime())));
        this.fechaFormateada = this.datePipe.transform(fechaMaximaDot, 'dd/MM/yyyy');
      }

     // this.updateMyDiag();
      this.allProjectDiagramations = this.projectDiagramations;
      let encontroUser;
      this.mydiag = [];

      this.projectDiagramations.map( (diagramation:any) => {
        const conf_vobos = diagramation.config_vobos;
        conf_vobos.map((cv:any) => {
          const vobos = cv.vobos;
          vobos.map((vb:any) => {
            encontroUser = vb.users.find( (user:any) => user == x.my_user_id);
            if(encontroUser != undefined){
              if (!this.mydiag.includes(diagramation.id)) {
                this.mydiag.push(diagramation.id);
              }
            }
          })
        })
      });

      this.myProjectDiagramations = this.projectDiagramations.filter( (obj:any) => {
        return this.mydiag.includes(obj.id);
      });

     
      this.updateSelectDiagramations();

      //Se agrega porcentaje de terminado a cada vobo
      this.projectPhases.map( (pp:any) => {

        //Se agrega primero a las phases de artes
        const files_aprobados = this.diagram_files.filter( (df:any) => df.id_phase == pp.id && df.aprobado == 1);
        
        const totalDiagramations = this.projectDiagramations.length;
        const porcentaje_terminado = totalDiagramations > 0 ? Number(((files_aprobados.length / totalDiagramations) * 100).toFixed(2)) : 0;
        pp.porcentaje_terminado = porcentaje_terminado;

        //Despues a los vobos
        pp.vobos.map((vb:any) => {
          let count_vobos_aprov = 0;
          this.projectDiagramations.map((pd:any) => {
            const c_vobos = pd.config_vobos.find( (cv:any) => cv.id == pp.id );
            count_vobos_aprov += c_vobos.vobos.filter( (vo:any) => vo.id == vb.id && vo.status == 1 ).length;
          })
      
          vb.porcentaje_terminado = totalDiagramations > 0 ? Number(((count_vobos_aprov / totalDiagramations) * 100).toFixed(2)) : 0;

        })

      })
    }, (err:any) => {
      console.log(err);
    });

  
  }



  findFile(id_diagrama: number, id_phase: number, diagrama?: any) {
    if (diagrama && this.medioUsaImagenesCompartidas(diagrama)) {
      const artesCompartidosFase = this.obtenerArtesCompartidosFase(diagrama, id_phase);
      if (artesCompartidosFase.length > 0 && this.tieneArteCompartidoAnotado(diagrama, id_phase)) {
        return artesCompartidosFase[0]?.aprobado;
      }
      return undefined;
    }

    const arte = this.diagram_files.find((e:any)=>e.id_diagrama == id_diagrama && e.id_phase == id_phase);
    return arte?.aprobado;
  }

  openEditProjectDiagramDialog(curr_diagram: any) {
    this.pollingSubscription?.unsubscribe();
    this.matDialog.open(ProjectDiagramationAddComponent, {
      panelClass: ['dialogs-xxl'],
      data: {
        id_proy: this.id_proy,
        id_proy_camp : this.id_proy_camp,
        projectData: this.project,
        promos: this.projectsS.promos_file_data,
        phases: this.projectPhases,
        data: this.projectDiagramations,
        projectAllDiagramations: this.projectAllDiagramations,
        curr_diagram,
        config_positions: this.config_positions,
        selected_medios : this.selected_medios,
        selected_attributes: this.selected_attributes
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.loadProyectData();
        }
        this.startPolling();
      }
    );
  }

  deleteProjectDiagramDialog(curr_diagram: any) {
    Swal.fire({
      title: '¿Está seguro que desea eliminar este Registro?. Esto no se puede deshacer.',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
    .then((willDelete) => {
      if (willDelete.isConfirmed) {
        this.projectsS.deleteProjectDiagram(curr_diagram.id).subscribe(
          (result:any) => {
            this.main.HideLoading();
            if(result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Eliminado',
                text: 'Diagrama eliminado correctamente'          
              }).then(x=>{
                this.loadProyectData();
              })
            }
            else {
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar',
                text: 'Ocurrió un error al eliminar el registro, por favor vuelve a intentarlo.'
              });
            }
          },
          (err:any) => {
            this.main.HideLoading();
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al eliminar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
      }
    });
  }

    openDiagramsLogs(dia: any) {
      this.matDialog.open(DiagramsLogsComponent, {
        panelClass: ['dialogs-md'],
        data: {
          diagrama: dia
        }
      }).afterClosed().subscribe(
        resp => {
          if (resp.reload){

          }
          this.loadProyectData();
        }
      );
    }

    openProjectSummary() {
      this.matDialog.open(ProjectDiagramationSummaryInventoryComponent, {
        panelClass: ['dialogs-xxl'],
        data: {
          id_proy: this.id_proy,
          projectData: this.project,
          projectAllDiagramations: this.projectAllDiagramations,
        }
      }).afterClosed().subscribe(
        resp => {
          if (resp.reload){

          }
        }
      );
    }


  openVobosDiagramDialog(diagram: any, phase: any, vobo: any, isConsecutivo: boolean = false) {
    if(this.getVoboObj(diagram.config_vobos, vobo)!= 3){
      this.matDialog.open(ProjectDiagramationVobosComponent, {
      panelClass: ['dialogs-xxl'],
      data: {
        phase,
        diagram,
        project: this.project,
        form_vb: this.form_vb.filter((f:any)=>vobo.vobos.includes(f.id)),
        vobo,
        campaign: this.campaign,
        arr_order: this.arr_order,
        projectConf : this.projectResponse,
        isConsecutivo : isConsecutivo,
        art_users : this.art_users,
        medioUsaImagenesCompartidas: this.medioUsaImagenesCompartidas(diagram),
        datosSharedArts: {
          vistaDirecta: true,
          idMedioDirecto: Number(diagram.id_medio),
          idPopDirecto: Number(diagram.id_pop),
          faseDirecta: phase,
          projectAllDiagramations: this.projectAllDiagramations,
          projectDiagramations: this.projectDiagramations,
          id_proy_camp: this.id_proy_camp,
          id_proyecto_campana: this.id_proy_camp,
          id_proyecto: this.id_proy,
          project: this.project,
          phases: this.projectPhases
        }
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp.reload){
          this.loadProyectData();
        }
          
      }
    );
    }else{
      //No tiene usuario Y es opcional
         Swal.fire({
          icon: 'warning',
          title: 'No hay usuarios configurados',
          text: 'No hay usuarios configurados para este formulario.'
        });
    }

  }

  openVobosDiagramConfigDialog() {
    this.matDialog.open(ProjectDiagramationVobosConfigComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        edit : true,
        data: this.projectDiagramations
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openUploadArtFIleDialog(diagram: any, phase: any){
    const artesCompartidosFase = this.obtenerArtesCompartidosFase(diagram, phase.id);
    const arteCompartidoSinAnotar = this.medioUsaImagenesCompartidas(diagram)
      && artesCompartidosFase.length > 0
      && !this.tieneArteCompartidoAnotado(diagram, phase.id);
    this.matDialog.open(ProjectsArtUploadComponent, {
      panelClass: ['dialogs-md'],
      data: {
        phase,
        diagram,
        project: this.project,
        projectName: this.project.nombre,
        arr_order: this.arr_order,
        projectConf : this.projectResponse,
        art_users : this.art_users,
        arteCompartidoSinAnotar,
        datosSharedArts: {
          vistaDirecta: true,
          idMedioDirecto: Number(diagram.id_medio),
          idPopDirecto: Number(diagram.id_pop),
          faseDirecta: phase,
          arteCompartidoActivo: artesCompartidosFase[0],
          projectAllDiagramations: this.projectAllDiagramations,
          projectDiagramations: this.projectDiagramations,
          id_proy_camp: this.id_proy_camp,
          id_proyecto_campana: this.id_proy_camp,
          id_proyecto: this.id_proy,
          config_positions: this.config_positions,
          selected_medios: this.selected_medios,
          project: this.project,
          campaing: this.campaign,
          phases: this.projectPhases,
          diagram_files: this.diagram_files
        }
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp.reload)
          this.loadProyectData();
      }
    );
  }

  async abrirArteDiagramacion(diagrama: any, fase: any): Promise<void> {
    if (!this.catalogoImagenesCompartidasCargado) {
      await this.cargarMediosConImagenesCompartidas();
    }
    const artesCompartidosFase = this.obtenerArtesCompartidosFase(diagrama, fase.id);

    if (this.medioUsaImagenesCompartidas(diagrama)) {
      this.abrirHistorialArteCompartido(diagrama, fase, artesCompartidosFase[0]);
      return;
    }

    this.openUploadArtFIleDialog(diagrama, fase);
  }

  private async cargarMediosConImagenesCompartidas(): Promise<void> {
    if (!this.id_proy_camp) return;
    this.catalogoImagenesCompartidasCargado = false;
    try {
      const respuesta: any = await this.projectsS.getMedios(this.id_proy_camp).toPromise();
      const medios = respuesta?.data?.medios || [];
      this.mediosConImagenesCompartidas = new Set(
        medios
          .filter((medio: any) => medio.imagenes_compartidas === true || Number(medio.imagenes_compartidas) === 1)
          .map((medio: any) => Number(medio.id))
      );
      this.extrapolarConfiguracionImagenesCompartidas();
      this.catalogoImagenesCompartidasCargado = true;
    } catch (error) {
      console.error('No fue posible consultar la configuración de imágenes compartidas de los medios.', error);
    }
  }

  private extrapolarConfiguracionImagenesCompartidas(): void {
    [this.projectAllDiagramations, this.projectDiagramations].forEach((diagramaciones: any[]) => {
      (diagramaciones || []).forEach((diagrama: any) => {
        diagrama.imagenes_compartidas = this.mediosConImagenesCompartidas.has(Number(diagrama.id_medio)) ? 1 : 0;
      });
    });
  }

  private medioUsaImagenesCompartidas(diagrama: any): boolean {
    return diagrama?.imagenes_compartidas === true
      || Number(diagrama?.imagenes_compartidas) === 1
      || this.mediosConImagenesCompartidas.has(Number(diagrama?.id_medio));
  }

  private obtenerArtesCompartidosFase(diagrama: any, idFase: number): any[] {
    const artesCompartidos = Array.isArray(diagrama?.artes_compartidos) ? diagrama.artes_compartidos : [];
    return artesCompartidos.filter((arte: any) =>
      Number(arte.id_phase || arte.id_fase) === Number(idFase)
    );
  }

  private tieneArteCompartidoAnotado(diagrama: any, idFase: number): boolean {
    let configuracionVobos: any[] = [];
    if (Array.isArray(diagrama?.config_vobos)) {
      configuracionVobos = diagrama.config_vobos;
    } else {
      try {
        configuracionVobos = JSON.parse(diagrama?.config_vobos || '[]');
      } catch {
        configuracionVobos = [];
      }
    }

    const configuracionFase = configuracionVobos.find((configuracion: any) =>
      Number(configuracion.id) === Number(idFase)
    );
    const valor = configuracionFase?.tieneArteCompartidoAnotado;
    return valor === true || Number(valor) === 1 || String(valor).toLowerCase() === 'true';
  }

  private async abrirHistorialArteCompartido(diagrama: any, fase: any, arteCompartido: any): Promise<void> {
    const contextoShared = await this.obtenerContextoSharedCampana();
    if (!contextoShared) return;
    this.matDialog.open(SharedArtsDiagramViewComponent, {
      panelClass: ['dialogs-xl'],
      disableClose: true,
      data: {
        vistaDirecta: true,
        idMedioDirecto: Number(diagrama.id_medio),
        idPopDirecto: Number(diagrama.id_pop),
        faseDirecta: fase,
        arteCompartidoActivo: arteCompartido,
        projectAllDiagramations: contextoShared.diagramaciones,
        projectDiagramations: contextoShared.diagramaciones,
        id_proy_camp: this.id_proy_camp,
        id_proyecto_campana: this.id_proy_camp,
        id_proyecto: this.id_proy,
        config_positions: this.config_positions,
        selected_medios: contextoShared.mediosSeleccionados,
        proyectosContexto: contextoShared.proyectos,
        project: this.project,
        campaing: this.campaign,
        phases: contextoShared.fases,
        diagram_files: this.diagram_files
      }
    }).afterClosed().subscribe(resp => {
      if (resp?.reload) this.loadProyectData();
    });
  }

    openUploadArtMultiFIleDialog(){
    this.matDialog.open(ProjectsArtMultiUploadComponent, {
      panelClass: ['dialogs-sm'],
      data: {
      project : this.project,
      projectConf : this.projectResponse[0],
      fases : this.projectPhases,
      art_users : this.art_users
      }
    }).afterClosed().subscribe(
      resp => {
        
          this.loadProyectData();
      }
    );
  }

  openInventoryDialog(){
    this.matDialog.open(ProjectsDiagramationInventoryComponent, {
      panelClass: ['dialogs-xxl'],
      data: {
        project: this.project
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  getPromoFactFile(){
    this.main.ShowLoading();
    this.projectsS.getPromotionData(this.campaign.id).subscribe((c: any) => {
      let proreturn =  this.projectDiagramations.map((pd:any)=> pd.promociones ).flat().map((pf:any)=>{

          let promotionFile = c.data.find((promo:any) => 
            promo['CODIGO PRINCIPAL'] == pf
           );

          return {
             "ID": pf,
            "REGISTROS" : "",
            "DIRECCION CORREO ELECTRONICO" : "",
            "ÁREA" : "",
            "MUNDO" : "",
            "DIVISIÓN" : "",
            "CATEGORÍA" : "",
            "PROVEEDOR" : promotionFile['PROVEEDOR'],
            "EMPRESA RECUPERADORA" : "",
            "LABORATORIO" : promotionFile['LABORATORIO'],
            "TIPO DE BONIFICACIÓN" : "",
            "FORMA DE RECUPERACIÓN" : "",
            "DESCRIPCIÓN" : "",
            "CORREO PROVEEDOR" : "",
            "CANAL DE VENTA" : "",
            "TIPO DE SOPORTE" : "",
            "CARGA TU SOPORTE" : "",
            "DESCRIPCIÓN O ETIQUETA DE LA NEGOCIACIÓN" : "",
            "MONTO" : "",
            "COMENTARIO ADICIONAL" : "",
            "FACTURA EMITIDA" : "",
          };
        });
        this.projectsS.getFacturasProject(this.project.id).subscribe((x:any)=>{
          this.main.HideLoading();
                 x.data.map((factura : any)=>{
                  const promosDiag = JSON.parse(factura.promociones);
  
                  let promotionFile = c.data.filter((promo:any) => 
                   promosDiag.includes(promo['CODIGO PRINCIPAL'])
                  );
                  proreturn.filter((pf:any)=> promosDiag.includes(pf.ID)).map((pf:any)=>{
                    Object.assign(pf,{
                      "REGISTROS" : factura.enviado,
                      "DIRECCION CORREO ELECTRONICO" : factura.email_usuario,
                      "EMPRESA RECUPERADORA" : factura.empresa_recuperadora,
                      "FORMA DE RECUPERACIÓN" : factura.metodo_pago,
                      "DESCRIPCIÓN" : factura.concepto,
                      "CORREO PROVEEDOR" : factura.email_proveedor,
                      "MONTO" : factura.monto,
                    })
                  })

                })
              
              this.main.generateExcel(proreturn, "Promo_FileDownload", "Data");
          
        });


    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  getExcelDiagramas(){
    this.main.ShowLoading();
    let diagramationsRet = 
      this.projectsS.getPromotionData(this.campaign.id).subscribe((c: any) => {
        const result: any[] = [];
        let promos = c.data;

        if (promos != undefined) {
          if (c.columnas.length > 0) {
            this.displayedColumns = c.columnas;
            this.displayedColumns = this.displayedColumns.map(col => col);
            this.loadColumnsByUser(this.campaign.id);
            this.columnsProm = Object.keys(promos[0]).filter(key => key && key.trim() !== '' && key.trim().toUpperCase() !== 'CODIGO PRINCIPAL');
            if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
              this.displayedColumns.unshift('CODIGO PRINCIPAL');
            }
            this.allColumns = ['select', ...this.displayedColumns];
          }
          else if (promos.length > 0) {
            const columnSet = new Set<string>();
            promos.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                if (key && key.trim() !== '') columnSet.add(key);
              });
            });
            this.displayedColumns = Array.from(columnSet);
            this.loadColumnsByUser(this.campaign.id);
            this.columnsProm = Array.from(columnSet).filter(key => key && key.trim() !== '' && key.trim().toUpperCase() !== 'CODIGO PRINCIPAL');
            if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
              this.displayedColumns.unshift('CODIGO PRINCIPAL');
            }
            this.allColumns = ['select', ...this.displayedColumns];
          }

        }

        this.projectDiagramations.forEach((d: any) => {
          d.promociones.forEach((codigo: any) => {
            const promo = promos.filter((p: any) => p['CODIGO PRINCIPAL'] === codigo);

            promo.forEach((pr: any) => {

              const colDis: any = {};

              this.displayedColumns.forEach((colum: any) => {
                colDis[colum] = pr[colum];
              })

              result.push({
                'ID': d.id,
                'ALIAS': d.alias ? d.alias : "",
                'COMENTARIOS': d.comentarios,
                'IMAGENES CARGADAS': d.count_files,
                'MEDIO': d.medio,
                'ELEMENTO': d.pop,
                'POSICION': d.posicion,
                'CANTIDAD': d.cantidad,
                'SUCURSALES': d.cant_sucursales,
                'CREADO POR': d.nombre_usuario,
                'STATUS': d.nameSigPhase == "" ? 'Terminado' : (d.idAreaSigVobo == 0 ? d.nameSigPhase + ' - ' + 'Diseño' : d.nameSigPhase + ' - ' + d.nextVobo.area),
                'USUARIO SIGUIENTE VOBO': d.sigUsuariosVobo.length != 0 ? d.sigUsuariosVobo[0].name ? d.sigUsuariosVobo[0].name : "-" : "-",
                ...colDis
              });

            })
          });

          this.main.HideLoading();

        });

        this.main.generateExcel(result, "Diagramaciones_Totales", "diagramas");

      });

  }

  openDistributionDialog(){
    this.matDialog.open(ProjectsDiagramationDistributionComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        project: this.project,
        campaign: this.campaign,
        promos : this.allpromos
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openDialogProviders(diagrama : any, phase : any, vobo : any) {
    let pop_c = this.pop_config.filter((x:any)=> x.id == diagrama.id);
    this.matDialog.open(ProjectsProvidersListComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        camp_id : this.project.id,
        folder : this.project.folder,
        nombre : diagrama.pop_config,
        id_proy_dia : diagrama.id,
        id_phase : phase.id,
        id_vobo : vobo.id,
        vobo: vobo,
        vobos : vobo.vobos,
        phase : phase,
        form_vb: this.form_vb,
        arr_order: this.arr_order,
        diagrama : diagrama,
        medioUsaImagenesCompartidas: this.medioUsaImagenesCompartidas(diagrama),
        campaign: this.campaign.id,
        promociones: diagrama.promociones,
        alias: diagrama.alias,
        pop_config : pop_c
      }
    }).afterClosed().subscribe(
      resp => {
        this.loadProyectData();
      }
    );
  }

  onlyPick3Lett(str: string): string {
    return str.substring(0, 3);
  }

  getVoboObj(diagram_vobos: any, vobo: any) {
    const phase = diagram_vobos.find((e:any)=>e.id==vobo.phase_id);
    const v = phase?.vobos?.find((e:any)=>e.id==vobo.id);
    //console.log(v.optional, v);
    if(v?.optional == true && v.users.length == 0){
      return 3;
    }else{
      return v?.status;
    }
  }

  hasPermisionToSee(diagrama : any) : boolean{
     const userIds = this.art_users.map((u:any) => u.id);
    if(this.userS.hasPermissions("diagram_super", null, this.userS.isClientUsr())  || userIds.includes(this.userId) || this.isDiagramOwner(diagrama)){
      return true;
    }else{
     return this.isUserInDiagrama(diagrama);
    }
  }

   isUserInDiagrama(diagrama : any) : boolean {
    for (const config of diagrama.config_vobos) {
      for (const vobo of config.vobos) {
        if (vobo.users.includes(this.userId)) {
          return true;
        }
      }
    }
    return false;
  }

  isDiagramOwner(diagrama : any){
    return diagrama.id_usuario === this.userId;
  }

  get filteredDiagramations() {
    if (!this.searchText) {
      return this.showProjectDiagramations;
    }

    const text = this.searchText.toLowerCase();

    return this.showProjectDiagramations.filter((diagram: any) => {
      const baseFields = [
        diagram.id,
        diagram.medio,
        diagram.pop,
        diagram.posicion,
        diagram.count_files,
        diagram.cantidad,
        diagram.cant_sucursales,
        diagram.nombre_usuario,
        diagram.alias,
        diagram?.sigUsuariosVobo[0]?.name
      ].join(' ').toLowerCase();

      return baseFields.includes(text);
    });
  }

  openModalUsuariosSigVobo(usuarios: any, area:any, fase:any){
    this.matDialog.open(UsuariosSigVoboComponent, {
      panelClass: ['dialogs-md'],
      data: {
        usuarios,
        area,
        fase
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openResumen(data: any, project: any){
    this.matDialog.open(ProjectDiagramationResumenComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        ...data,
        project: project
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  imprimirSucursales(diagrama: any): void {
    const sucursalesIds = diagrama.pop_config?.[0]?.sucursales?.map((sucursal: any) => sucursal.id) || [];

    if (sucursalesIds.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'Sin sucursales',
        text: 'Esta diagramación no tiene sucursales asignadas.'
      });
      return;
    }

    this.main.ShowLoading();
    this.projectsS.getSucursalesById(sucursalesIds).subscribe(
      (response: any) => {
        const sucursales = (response.data || []).map((sucursal: any) => ({
          Plaza: sucursal.Plaza,
          FarmID: sucursal.FarmID,
          Nombre: sucursal.Nombre
        }));

        this.main.HideLoading();
        this.main.generateExcel(
          sucursales,
          `Sucursales_Diagramacion_${diagrama.id}`,
          'Sucursales',
          '',
          ['Plaza', 'FarmID', 'Nombre']
        );
      },
      (err: any) => {
        console.log(err);
        this.main.HideLoading();
        Swal.fire({
          icon: 'error',
          title: 'Error al generar el Excel',
          text: 'No fue posible obtener las sucursales de la diagramación.'
        });
      }
    );
  }


    openReset(data: any){

      const userIds = this.art_users.map((u:any) => u.id);
    this.matDialog.open(ProjectDiagramResetsComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        fases: this.projectPhases,
        vobos : data.config_vobos,
        id_diagrama : data.id,
        usr_art : userIds,
        artes_compartidos: this.medioUsaImagenesCompartidas(data)
          ? (data.artes_compartidos || [])
          : []
      }
    }).afterClosed().subscribe(
      resp => {
          this.loadProyectData();
        }
    );
   }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.projectsS.hasPermissions(key, buho, client);
  }

  //Para select de ver solo asignadas a mi o todas
  updateSelectDiagramations(){
    if(this.selectVerDiagramacion == '1'){
      this.showProjectDiagramations = this.myProjectDiagramations;
    }
    else{
      this.showProjectDiagramations = this.allProjectDiagramations;
    }
    this.updateFiltroDiagramations()
  }

  //Para select de atrasadas, proximas y pendientes
  updateFiltroDiagramations(){

    const fechaProximaAVencer = new Date(this.fechaActual);
    fechaProximaAVencer.setDate(fechaProximaAVencer.getDate() + 3);

    if (this.selectDiagramacionFiltro != '0') {
      
      let newObjDiagramations: any= new Array<ProjectVobo>();

      this.showProjectDiagramations.map((pd: any) => {

        this.projectPhases.map((pp: any) => {
          if (pd.idAreaSigVobo > 0) { //Cuando no sea arte
            const vobos = pp.vobos;
            vobos.map((vb: any) => {
              if (vb.id == pd.idAreaSigVobo && vb.phase_id == pd.idPhaseSigVobo) {
                this.fechaSigVobo = vb.fecha_limite;
              }
            })
          }
          else {
            if(pp.id == pd.idPhaseSigVobo){
              this.fechaSigVobo = pp.fecha_limite
            }
          }
        })

        let fechaFSigVobo = new Date(this.fechaSigVobo);

        if (fechaFSigVobo && this.fechaActual) {
          //Atrasadas
          if(this.selectDiagramacionFiltro == '1'){
            if (fechaFSigVobo < this.fechaActual) {
              newObjDiagramations.push(pd);
            }
          }
          //Proximas a vencer
          else if(this.selectDiagramacionFiltro == '2'){
            if (fechaFSigVobo >= this.fechaActual && fechaFSigVobo <= fechaProximaAVencer) {
              newObjDiagramations.push(pd);
            }
          }
          //Pendientes
          else if(this.selectDiagramacionFiltro == '3'){
            if (pd.sigUsuariosVobo.length > 0) {
              newObjDiagramations.push(pd);
            }
          }
          //Todas
          else if(this.selectDiagramacionFiltro == '4'){
            newObjDiagramations.push(pd);
          }

        }

      })
      this.showProjectDiagramations = newObjDiagramations;
      if(this.selectDiagramacionFiltro == '4'){
        this.showProjectDiagramations.sort((a: any, b: any) => a.id - b.id);
      }
    }
      
  }

  getMyNextDiagramas() : any[]{
    const nextDiagrams = [];
    for (const diagram of this.myProjectDiagramations) {
      if (diagram.nextVobo && diagram.nextVobo.users && diagram.nextVobo.users.includes(this.userId)) {
        const phase = this.projectPhases.find((p: any) => p.id === diagram.idPhaseSigVobo);
        if (phase) {
          const voboConfig = phase.vobos.find((v: any) => v.id === diagram.nextVobo.vobo_id);
          if (voboConfig && voboConfig.is_provider_vobo !== 1) {
            nextDiagrams.push({ id_diagrama: diagram.id, vobo_id: diagram.nextVobo.vobo_id, phase_id: diagram.idPhaseSigVobo, reviewed: false });
          }
        }
      }
    }
    return nextDiagrams;
  }

  async openAutomaticVobo(){
     let listDiagramasEvaluate = this.getMyNextDiagramas();
     //console.log(listDiagramasEvaluate, this.projectPhases);
     if(listDiagramasEvaluate.length > 0){
 
      for (const diagramEva of listDiagramasEvaluate) {
        const diagram = this.projectDiagramations.find((d:any)=>d.id == diagramEva.id_diagrama);
        const phase = this.projectPhases.find((p:any) => p.id === diagramEva.phase_id);
        const vobo = phase.vobos.find((v:any) => v.id === diagramEva.vobo_id);
 
        const dialogRef = this.matDialog.open(ProjectDiagramationVobosComponent, {
          panelClass: ['dialogs-xxl'],
          data: {
            phase,
            diagram,
            project: this.project,
            form_vb: this.form_vb.filter((f:any)=>vobo.vobos.includes(f.id)),
            vobo,
            campaign: this.campaign,
            arr_order: this.arr_order,
            projectConf : this.projectResponse,
            isConsecutivo : true,
            listEvaluate : listDiagramasEvaluate,
            art_users : this.art_users,
            medioUsaImagenesCompartidas: this.medioUsaImagenesCompartidas(diagram)
          }
        });
 
        const resp = await dialogRef.afterClosed().toPromise();
 
        if (resp?.reload) {
          diagramEva.reviewed = true;
     
        } else {
          
          break;
        }
      }

      if(listDiagramasEvaluate.filter((x:any)=> x.reviewed == true).length ==  listDiagramasEvaluate.length){
         Swal.fire({
          icon: 'success',
          title: 'Proceso completado',
          text: 'Se han evaluado todos los formularios pendientes a revisión.'
        });
      }
      
       this.loadProyectData();
     }else{
         Swal.fire({
          icon: 'warning',
          title: 'No hay formularios',
          text: 'No hay formularios pendientes por contestar.'
        });
     }
  }

  loadColumnsByUser(id: number){
    this.projectsS.getColumnsPromotionsByUser(id).subscribe((x: any) => {
      
      this.selectedColumns = x.data ?? [];
      this.loadingPromColumns = false
      if(this.selectedColumns.length == 0){
        this.tieneColGuardadas = false;
        this.selectedColumns = this.columnsProm;
      }
      else{
        const coincidencias = this.selectedColumns.filter(item => this.columnsProm.includes(item));
        this.selectedColumns = coincidencias;
      }
    },
    (err:any) => {
      console.log(err);
    })
  }


  startDragging(e: MouseEvent): void {

    const target = e.target as HTMLElement;
    if (target.classList.contains('selectable-text') || target.closest('.selectable-text')) {
   
      return;
    }

    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.isDragging = true;
      this.startX = e.pageX - this.scrollContainer.nativeElement.offsetLeft;
      this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
      this.scrollContainer.nativeElement.style.cursor = 'grabbing';

      // this.scrollContainer.nativeElement.classList.add('dragging');
    }
  }

  onDragging(e: MouseEvent): void {
    if (!this.isDragging) return;
    e.preventDefault();
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      const x = e.pageX - this.scrollContainer.nativeElement.offsetLeft;
      const walk = (x - this.startX) * 2; // Ajustar la velocidad de desplazamiento aquí (multiplicador 2)
      this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
    }
  }

  stopDragging(): void {
    this.isDragging = false;
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.style.cursor = 'grab';
     
      // this.scrollContainer.nativeElement.classList.remove('dragging');
    }
  }

  getDiagramaMenciones(id_diagrama : number){
    return this.menciones.filter((x:any)=> x.id_diagrama == id_diagrama).length;
  }

  exportDiagrama(id_diagrama:number){
    this.exportDiagramaciones([id_diagrama]);
  }

  exportDiagramaciones(ids_diagrama : Array<number>){
    const diagramationsP = this.projectAllDiagramations.filter((x:any)=> ids_diagrama.includes(x.id));
    const importObj = diagramationsP.map((item:any) => ({
     medio: item.medio,
     pop: item.pop,
     posicion: item.posicion,
     alias : item.alias,
     sucursales: item.pop_config[0].sucursales.map((x:any) => x.id),
     config_vobos: JSON.parse(item.config_vobos),
     promociones: JSON.parse(item.promociones)
    }));

      // Crear el archivo JSON
  const blob = new Blob([JSON.stringify(importObj, null, 2)], {
    type: 'application/json',
  });

  // Descargar el archivo
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'diagramaciones_export.json';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
      Swal.fire(
        '¡Exportado!',
        'El archivo de diagramaciones se ha generado correctamente.',
        'success'
      );
  }

  OpenImportDiagrama(){
    this.matDialog.open(ProjectDiagramationImportComponent, {
      panelClass: ['dialogs-md'],
      data: {
        id_proy: this.id_proy,
        id_proy_camp : this.id_proy_camp,
        projectData: this.project,
        promos: this.projectsS.promos_file_data,
        phases: this.projectPhases,
        data: this.projectDiagramations,
        projectAllDiagramations: this.projectAllDiagramations,
        config_positions: this.config_positions,
        selected_medios : this.selected_medios,
        selected_attributes: this.selected_attributes
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.loadProyectData();
        }
      }
    );
  
  }

    OpenExportDiagrama(){
    this.matDialog.open(ProjectDiagramationExportComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        projectDiagramations: this.projectAllDiagramations,
        config_positions: this.config_positions,
        selected_medios : this.selected_medios,
        phases: this.projectPhases,
        project : this.project,
        campaing : this.campaign
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.loadProyectData();
        }
      }
    );
  
  }

    async OpenExportSharedArtsDiagrama(){
    const contextoShared = await this.obtenerContextoSharedCampana();
    if (!contextoShared) return;
    this.matDialog.open(SharedArtsDiagramViewComponent, {
      panelClass: ['dialogs-xl'],
      disableClose: true,
      data: {
        projectAllDiagramations: contextoShared.diagramaciones,
        projectDiagramations: contextoShared.diagramaciones,
        id_proy_camp: this.id_proy_camp,
        id_proyecto_campana: this.id_proy_camp,
        id_proyecto: this.id_proy,
        config_positions: this.config_positions,
        selected_medios: contextoShared.mediosSeleccionados,
        proyectosContexto: contextoShared.proyectos,
        project : this.project,
        campaing : this.campaign,
        phases: contextoShared.fases,
        diagram_files: this.diagram_files,
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.loadProyectData();
        }
      }
    );
  
  }

  private async obtenerContextoSharedCampana(): Promise<any> {
    this.main.ShowLoading();
    try {
      const respuesta: any = await this.projectsS.getProjectsSlim(this.id_proy_camp).toPromise();
      const contexto = respuesta?.data || respuesta || {};
      const proyectos = contexto.proyectos || {};
      const medios = new Set<number>();
      Object.values(proyectos).forEach((proyecto: any) => {
        const seleccionados = Array.isArray(proyecto.selected_medios)
          ? proyecto.selected_medios
          : JSON.parse(proyecto.selected_medios || '[]');
        seleccionados.forEach((idMedio: any) => medios.add(Number(idMedio)));
      });
      this.main.HideLoading();
      return {
        diagramaciones: (contexto.diagram_all || []).map((diagrama: any) => ({
          ...diagrama,
          idProyectoContexto: Number(diagrama.id_proyecto)
        })),
        proyectos,
        fases: contexto.groupedPhases || [],
        mediosSeleccionados: Array.from(medios)
      };
    } catch (error) {
      this.main.HideLoading();
      console.error('No fue posible cargar el contexto de artes compartidos.', error);
      Swal.fire('Error', 'No fue posible abrir los artes compartidos de la campaña.', 'error');
      return null;
    }
  }
  
}
